import { z } from 'zod'

type SplitPath<P extends string> = P extends `${infer X}/${infer Y}` ? X | SplitPath<Y> : P
type KeepPathVar<P extends string> = P extends `$${infer Var}` ? Var : never
type AsRecord<T extends string> = [T] extends [never] ? never : { [K in T]: string }

export type PreferenceConfig<Schema = any, Default extends Schema = Schema, Error extends Schema = Schema> = {
  schema: z.ZodType<Schema>
  default: Default // TODO the default value doesn't work with the schema type yet so it's not enforced in the types
  error?: Error // TODO the error value doesn't work with the schema type yet so it's not enforced in the types
}

export type PathParams<P extends string> = AsRecord<KeepPathVar<SplitPath<P>>>

export const resolveKey = (props: { path: string; params?: Record<string, string> }) => {
  const params = 'params' in props ? props.params ?? {} : {}
  return Object.keys(params).reduce((acc, key) => acc.replace(`$${key}`, (params as any)[key]), props.path)
}
